import { identifyUserByEmail, trackLogin } from './analytics/HubspotService';
import { setTokens } from './AuthenticationService';
import { Logger } from './Logger';
import { getUserMetadata } from './UserService';

export async function initAppOnAuthentication(authResult): Promise<void> {
	setTokens(authResult);
	try {
		const userData = await getUserMetadata();
		identifyUserByEmail(userData.email);
		trackLogin();
	} catch (error) {
		Logger.error('Error getting user details, could not init hubspot API');
	}
}
